import { createSelector } from '@ngrx/store';
import { BaseState } from '../base.state';

export const selectUWQuestionsState = (state: BaseState) => state.uwQuestions;

export const selectUWQuestionsIsLoading = createSelector(
  selectUWQuestionsState,
  (state) => state.isLoading
);